import React from 'react'
import { browserHistory } from 'react-router'
import { user } from '../../../core/controllers/user';
import TransactionsTable from '../../../components/Admin/Transactions/TransactionsTable';
import NavLink from '../../../components/Routes/NavLink';

import ProcessedMoneyCard from '../../../components/Admin/Transactions/ProcessedMoneyCard'
import CancelledTransactionsCard from '../../../components/Admin/Transactions/CancelledTransactionsCard'
import LateRentAmountCard from '../../../components/Admin/Transactions/LateRentAmountCard'

export default class AdminTransactions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: 'month',
            transactionHistory: null,
        }
    }

    componentDidUpdate() {
        if (user.userInfo.user_type_alias != 'super-admin') {
            browserHistory.replace('/');
        }
    }

    handleFilterChange(e) {
        this.setState({
            filter: e.target.value
        });

        // financial.setLimit(e.target.value);
        this.getTransactionHistory();

        this.forceUpdate();
    }

    getTransactionHistory() {
        // var self = this;
        // financial.getTransactionHistory(function(response){
        //     self.setState({
        //         transactionHistory: response.data,
        //     });
        // });
    }

    render(){
        return (
            <div>
                <div class="row">
                    <div class="main-page-header-row col-md-12">
                        <div class="col-md-3">
                            <span class="main-page-header-title">Transactions</span>
                        </div>
                        <div class="col-md-2 col-md-offset-7">
                            <NavLink to={"/admin/transactions"}> {/* TODO: change NavLink to the correct path */}
                                <button type="button" id="add-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                    Add Transaction
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="date-range" style={{color: "#FFFFFF"}}>Select Date Range</label>
                            <select class="form-control" value={this.state.filter} onChange={this.handleFilterChange.bind(this)}>
                                <option value='month'>Current Month</option>
                                <option value='threemonths'>3 Months</option>
                                <option value='sixmonths'>6 Months</option>
                                <option value='all'>All History</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <ProcessedMoneyCard clickable={false}/>
                    <CancelledTransactionsCard clickable={false}/>
                    <LateRentAmountCard clickable={false}/>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Transaction History</h4>
                                <p class="category">Complete list of all transactions made</p>
                            </div>
                            <div class="content">
                                <TransactionsTable transactionHistory={this.state.transactionHistory} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Admin/Transactions/AdminTransactions.jsx